<template>
  <div class="home-page page">
    <div class="page-wrap" v-if="displayPage">
      <div class="business-wrap" v-animate-on-scroll="'animate__backInDown'">
        <div class="title">
          <span class="chinese-name">欢迎访问通文人才网站</span>
          <span class="english-name"> 请选择要访问的模块</span>
        </div>
        <div class="tab-wrap">
          <div class="item bg-wrap-1" @click="handleWebSite('2')">
            <div class="title-1">集美区公共实训基地 </div>
            <div class="title-1">人力资源服务业与制造业融合发展平台 </div>
            <div class="desc">人力资源服务业与制造业融合发展平台 </div>
            <div class="tab-more">
              <span>点击进入</span>
            </div>
          </div>
          <div class="item bg-wrap-2" @click="handleWebSite('1')">
            <div class="title-1">福建通文产业服务有限公司 </div>
            <div class="title-1"> </div>
            <div> </div>
            <div class="desc">高质量就业服务提供商 </div>
            <div class="tab-more">
              <span>点击进入</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      displayPage: true,
    }
  },
  methods: {
    handleWebSite(type) {
      if (type == '1') {
        this.$router.push('/home');
      } else if (type == '2') {
        this.$router.push('/train');
      }

    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path == "/") {
          this.displayPage = true;
        } else {
          this.displayPage = false;
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;
  display: flex;
  background-image: url("https://static.fjtwfw.com/static/fjtwfw/news_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  .business-wrap {
    .title {
      margin-top: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      padding-top: 40px;
      font-family: "Arial", sans-serif;
      letter-spacing: 2px;

      .chinese-name {
        font-size: 40px;
        padding-left: 17px;
        font-weight: 700;
        background: linear-gradient(to bottom, #2993ec, #074bd4);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-weight: bold;
      }
      .english-name {
        margin-top: 30px;
        font-size: 20px;
      }
    }
    .tab-wrap {
      margin: 50px auto;
      width: 1400px;
      display: flex;
      justify-content: center;
      .item {
        border: 1px solid #e3e9ed;
        padding: 20px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 1.5rem !important;
        line-height: 2rem !important;
        width: 500px;

        .title-1 {
          text-align: center;
          width: 100%;
          padding-top: 10px;
        }

        .desc {
          font-size: 16px;
          text-align: center;
        }
        .tab-more {
          border: 1px solid #2a79ee;
          color: #2a79ee;
          font-size: 16px;
          width: 50%;
          height: 3rem !important;
          margin: 0px auto;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.25rem !important;
          cursor: pointer;
          margin-top: 80px;
        }
      }
      .item:hover {
        color: #fff;
        padding: 20px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 1.5rem !important;
        line-height: 2rem !important;
        width: 500px;

        .tab-more {
          border: 1px solid #fff;
          color: #fff;
          font-size: 16px;
          width: 50%;
          height: 3rem !important;
          margin: 0px auto;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.25rem !important;
          cursor: pointer;
          margin-top: 80px;
        }
      }
      .bg-wrap-1 {
        margin-right: 100px;
        background-image: url("https://static.fjtwfw.com/static/image/bg_20.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom !important;
      }
      .bg-wrap-1:hover {
        margin-right: 100px;
        background-image: url("https://static.fjtwfw.com/static/image/bg_22.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom !important;
      }
      .bg-wrap-2 {
        background-image: url("https://static.fjtwfw.com/static/image/bg_21.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom !important;
      }
      .bg-wrap-2:hover {
        background-image: url("https://static.fjtwfw.com/static/image/bg_22.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom !important;
      }
    }
  }
}
</style>